import React from 'react';

import PagePreview from '../../components/PagePreview';
import Fact from '../../components/Fact';
import Quote from '../../components/Quote';
import Title from '../../components/Title';
import Spreader from '../../components/Spreader';
import Map from '../../components/Map';
import Menu from '../../components/Menu';

import { StickyContainer } from 'react-sticky';

const IndexPage = props => (
  <StickyContainer>
    <Menu active="index" showHeader />
    <PagePreview
      title="Глаз не отвести"
      description="Архитектура&nbsp;&mdash; единственное из&nbsp;всех направлений искусства, от&nbsp;которого нельзя отвернуться. Горожане ежедневно, хотят они этого или нет, видят город, в&nbsp;котором живут. От&nbsp;того, что они видят, зависит их&nbsp;настроение, самочувствие и&nbsp;даже мироощущение: красивый, успешный город притягивает красивых и&nbsp;успешных людей. Понятно, что Москва&nbsp;&mdash; город неоднородный, и&nbsp;в&nbsp;каждом конкретном месте и&nbsp;у&nbsp;каждого нового проекта уникальная миссия, зависящая от&nbsp;городского контекста. В&nbsp;исторической части города проекты не&nbsp;должны доминировать над застройкой, но&nbsp;дополнять ее&nbsp;и&nbsp;подчеркивать достоинства старинного города. В&nbsp;других районах, напротив, создавать доминанты места и&nbsp;становиться визуальными маркерами, открыточными видами локации и&nbsp;точками для селфи местного сообщества. Где-то современная застройка и&nbsp;вовсе является градообразующей, создает новые градостроительные оси, формирует улицы и&nbsp;проспекты."
      limitDescription={160}
      link="/architecture"
      image="images/media/arhitecture1.jpg"
      sticker={
        <Fact
          title="Жизнь по-новому"
          description="Зачастую яркие девелоперские проекты могут стать новой доминантой районов старой застройки или вдохнуть жизнь в те кварталы, которые требуют обновления. Как это делает «Галс»? "
        />
      }
    />
    <PagePreview
      title="Гений места"
      description="Как бы ни ругали экономическое положение граждан и современное состояние рынка недвижимости, эксперты, безусловно, сходятся в одном: покупатель недвижимости любого класса остается в выигрыше. Рынок покупателя стимулирует застройщиков делать продукт, отличающийся от конкурентов: лучше, элегантнее, продуманнее и удобнее для клиентов. И чем дальше, тем больше шансов найти жилой комплекс с опциями, характерными для предложения более высокого класса. Предложения комфорт-класса получают черты комплексов бизнес-класса, бизнес стремится к премиуму, получает ранее недоступные в этом классе опции в отделке общественных зон, квартирографии, дизайне дворовых территорий, инфраструктурных решениях."
      link="/genious"
      limitDescription={240}
      image="images/media/availability.png"
      sticker={
        <Fact
          title="Как жить"
          description="Рынок довольно жестко стоит на своем: элитный статус жилого комплекса определяется местом и только им. Но сейчас «Галс» разрушил этот стереотип: статус – это не место жизни, а ее качество. Статус – пространство, наполненное смыслом и содержанием."
        />
      }
    />
    <PagePreview
      title="Стремление вверх"
      description="Современный мегаполис немыслим без высотных зданий. И дело даже не в том, что вертикально можно построить больше метров на небольшом участке земли. Высотное строительство – это амбиции. И в первую очередь амбиции тех, кто выбирает жизнь на высоте. "
      link="/matchpoint"
      limitDescription={240}
      image="images/media/main_3.jpg"
      sticker={
        <Fact
          title="Символы победы"
          description="Московские высотки 50-х довольно долгое время оставались единственными доминантами города. Жить в таком доме, смотреть на города с высоты было привилегией. Почти через полвека новый статус шагающего в ногу с веком мегаполиса потребовал строительства небоскребов, символизирующих взгляд в будущее, энергию, силу, динамику города, который никогда не спит. И вновь – работать и жить на высоте – привилегия."
        />
      }
    />
    <PagePreview
      title="Проект красит место"
      description="Основное потребительское качество недвижимости, отличающее ее от остальных товаров – невозможность перемещения объекта в пространстве. Можно изменить проектное решение, цвет фасада и даже вид разрешенного использования, но изменить местоположение и перенести дом, скажем, на «Золотую милю» ну никак не получится. Зато хороший девелоперский проект вполне может создать свою, если не «золотую», то хотя бы «бронзовую» милю в другом районе города, поднять его статус на несколько ступеней вверх, улучшить городскую среду, изменить отношение местных жителей к своему району, добавить престижа и – постепенно изменить и состав населения. "
      link="/place"
      limitDescription={240}
      image="images/media/main_4.jpg"
      sticker={
        <Fact
          title="Энергия архитектуры"
          description="Match Point призван добавить драйва тихой размеренной жизни района Филевский парк. Проект интересен в первую очередь динамичной аудиторией, на которую он рассчитан. Энергия и динамика видны сразу в всем – и в архитектуре, и в инфраструктуре."
        />
      }
    />
  </StickyContainer>
);

export default IndexPage;
